module.exports = __webpack_public_path__ + "img/pink-star-bold-24x24.278187a7.svg";